import React, { useContext } from 'react';
import { AmplifyAuthenticator, AmplifySignIn, AmplifySignUp } from '@aws-amplify/ui-react';
import { makeStyles, Theme, createStyles, Typography } from '@material-ui/core';
import queryString from "query-string"
import { LoginContext } from '../Providers/LoginContextProvider';
import { Redirect } from 'react-router-dom';
import { useTranslation } from "react-i18next"


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
        margin: "8px",
    },
  }),
);

export interface Props {
    to: string
}

const NotFound = (props: Props) => {

    const classes = useStyles()
    const [t] = useTranslation()

    const params = queryString.parse(props.to)
    const loginProvider = useContext(LoginContext)

    return (
        <div className={classes.root}>
            <div>
                <Typography variant="h1">{t("message.notfound.code")}</Typography>
                <Typography>{t("message.notfound.message")}</Typography>
            </div>
            <div>
                <AmplifyAuthenticator>
                    <AmplifySignIn
                        slot="sign-in"
                        usernameAlias="email"
                    >
                    </AmplifySignIn>
                    <AmplifySignUp 
                        slot="sign-up"
                        usernameAlias="email"
                        formFields={[
                            {
                                type: "email",
                            },
                            {
                                type: "password"
                            },
                        ]}
                    >
                    </AmplifySignUp>
                </AmplifyAuthenticator>
            </div>
            {
                loginProvider.login && typeof params.redirect === "string" ? <Redirect push to={params.redirect} /> : null
            }
        </div>
    )
}
export default NotFound